import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/**Models */
import { Device } from '@models/device';

/*Services */
import { StateService } from '@services/state.service';
import { DevicesService } from '@services/http/devices.service';
import { AuthService } from '@services/http/auth.service';
import { CachedDataService } from '@services/data/cached-data.service';

/*Plugins */
import { BsModalComponent } from 'ng2-bs3-modal';

declare var swal: any;


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'update-password-modal',
  templateUrl: './update-password-modal.component.html'
})

export class UpdatePasswordModalComponent implements OnDestroy {

  @ViewChild('updatePasswordModal') updatePasswordModal: BsModalComponent;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  updatePasswordForm: FormGroup;
  currentDevice: Device;
  paymentUrl = null;
  errorText = null;
  trySend = false;
  ifShowOnce = false;
  errorMessage;
  
  showClose = true;
  showPasswordParam =false;

  btnText: any = {
    text: 'Обновить',
    defaultText: 'Обновить',
    loadText: 'Обработка..'
  };

  constructor(
    private stateService: StateService,
    private formBuilder: FormBuilder,
    private devicesService: DevicesService,
    private authService: AuthService,
    private cachedDataService: CachedDataService,
  ) {
    this.authService.needUpdatePasswordObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(() => {
        if (!this.ifShowOnce) {
          this.ifShowOnce = true;
          this.showClose = false;
          this.cachedDataService.needUpdatePassword = true;
          this.open();

        }
      });
    this.authService.userUpdatePasswordSubject
      .takeUntil(this.ngUnsubscribe)
      .subscribe(() => {
        this.showClose = true;
        this.cachedDataService.needUpdatePassword = false;
        this.open();
      });

    this.stateService.currentDeviceObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {
        this.currentDevice = device;

      });
  }



  initForm() {
    if(this.cachedDataService.needUpdatePassword){
      this.updatePasswordForm = this.formBuilder.group({
        newPassword: ['', [Validators.required]],
        newPasswordCheck: ['', [Validators.required]],
        ProviderAccountId: [''],
        isLocal: true
      });
    }else{
      this.updatePasswordForm = this.formBuilder.group({
        oldPassword: ['', [Validators.required]],
        newPassword: ['', [Validators.required]],
        newPasswordCheck: ['', [Validators.required]],
        ProviderAccountId: [''],
        isLocal: false
      });
    }
    this.updatePasswordForm.controls['ProviderAccountId'].setValue(this.currentDevice.providerAccountId);
  }

  submit() {
    if (this.trySend) {
      return false;
    }
    this.errorMessage = null;
    if (this.updatePasswordForm.invalid) {
      const controls = this.updatePasswordForm.controls;
      Object.keys(controls)
        .forEach(controlName => controls[controlName].markAsTouched());
      return;
    }

    if (this.updatePasswordForm.value.newPassword !== this.updatePasswordForm.value.newPasswordCheck) {
      this.errorMessage = 'Подтверждение не совпадает с паролем';
      return false;
    }
    this.trySend = true;
    this.btnText.text = this.btnText.loadText;

    this.devicesService.updatePassword(
      this.updatePasswordForm.value.newPassword,
      this.cachedDataService.needUpdatePassword ? null : this.updatePasswordForm.value.oldPassword,
      this.updatePasswordForm.value.ProviderAccountId,
      this.updatePasswordForm.value.isLocal,
    )
      .subscribe(response => {
        this.trySend = false;
        this.btnText.text = this.btnText.defaultText;

        this.ifShowOnce = false;
        if (!this.cachedDataService.needUpdatePassword) {
          swal({
            type: 'success',
            text: 'Пароль изменен',
            showConfirmButton: false,
            timer: 3000,
          });
        }else{
          this.stateService.loadState();
        }
        this.close();
      },
        error => {

          let errorMessage = 'Ошибка, проверьте корректность данных или повторите позже';
          if (error.error) {
            error = error.error;
          }
          if (error.capchaId && error.capchaUri) {

          } else if (error.errorMessage && error.errorMessage.length > 0) {
            errorMessage = error.errorMessage;

          }
          this.errorMessage = errorMessage;
          this.trySend = false;
          this.btnText.text = this.btnText.defaultText;
          console.log(error.type);
        }
      );
  }
  open() {
    this.initForm();
    this.updatePasswordModal.open();
  }

  close() {
    this.updatePasswordModal.close();
  }
  showPassword(){
    this.showPasswordParam = ! this.showPasswordParam;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/view/modal/update-password-modal/update-password-modal.component.ts